<div class="icon" [ngSwitch]="item.type">
  <ix-icon *ngSwitchCase="PermissionsItem.Group" name="people"></ix-icon>
  <ix-icon *ngSwitchCase="PermissionsItem.Other" name="groups"></ix-icon>
  <ix-icon *ngSwitchDefault name="person"></ix-icon>
</div>
<div class="name">{{ item.name }}</div>
<div class="permissions">{{ item.description }}</div>
